import React from 'react';
import cn from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as CrossIcon } from 'assets/img/icons/close.svg';

export default function EmailBadges({
  emails = [],
  disabled = true,
  onDelete = () => {},
  wrapperClassName = '',
  emptyBlockMsg = 'No recipients added.'
}) {
  const emailsList = emails.map(mail => (
    <UiKit.Tag key={mail} className={styles.badge}>
      <span className={styles.email}>{mail}</span>
      <CrossIcon className={styles.cross} onClick={() => onDelete(mail)} />
    </UiKit.Tag>
  ));

  return (
    <div
      className={cn(styles.container, wrapperClassName)}
      data-disabled={disabled}
    >
      <If
        test={!_isEmpty(emailsList)}
        otherwise={<span className={styles.empty}>{emptyBlockMsg}</span>}
      >
        {emailsList}
      </If>
    </div>
  );
}
